<template>
  <div>
    <v-data-table
      v-if                 = "currentDirectory"
      :headers             = "headers"
      :items               = "currentDirectoryToDisplay.items"
      @click:row           = "$emit('table-row-clicked', $event)"
      :items-per-page      = "itemsPerPage"
      :server-items-length = "totalEntries"
      :footer-props        = "{itemsPerPageOptions: [200, 500, 1000]}"
      @update:options      = "$emit('update-options', $event)"
      :dense               = "windowWidth <= 800"
      :mobile-breakpoint   ="800"
      :sort-by             ="sortByTable"
      :sort-desc           = "sortDescTable"
      :height              = "tableHeight"
    >
      <template v-slot:item.name="{ item }">
        <FileExplorerItemRow :item = "item"
                             :icon = "'mdi-clipboard-play'"
        ></FileExplorerItemRow>
      </template>
      <template v-slot:item.length="{ item }">
        {{ item.length | formatFileSize }}
      </template>
      <template v-slot:item.lastModified="{ item }">
        {{ item.lastModified | formatDate }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-menu v-if="(item.length && (videoPath || extensionSupportedInOpenMode(item.physicalPath)))">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon
                   @click ="onOptionsClick"
                   v-bind ="attrs"
                   v-on   ="on"
            >
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list style="cursor: pointer">
            <v-list-item
              v-if   ="videoPath"
              :key   ="1"
              @click ="$emit('load-subtitles', item.physicalPath)"
            >
              <v-list-item-title>Load as sidecar subtitles</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if   = "videoPath"
              :key   = "2"
              @click = "addAudioPath(item.physicalPath)"
            >
              <v-list-item-title>Add to audio paths configuration</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if   = "extensionSupportedInOpenMode(item.physicalPath)"
              :key   = "3"
              @click = "$emit('load-growing-file', item)"
            >
              <v-list-item-title>Open as Growing File</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FileExplorerItemRow from './FileExplorerItemRow';
import { mapState } from 'vuex';
import { SET_AUDIO_PATHS_CONFIG } from '@/utils/mutation-types';
import { restoreFileBrowserOpenModeExtensions } from '@/store/utilities/persistence.utils.js';

export default {
  name:       'FolderTable',
  components: { FileExplorerItemRow },
  props:      [
    'currentDirectory',
    'currentDirectoryToDisplay',
    'itemsPerPage',
    'totalEntries',
    'sortByTable',
    'sortDescTable',
    'height',
  ],
  data: function () {
    return {
      headers: [
        {
          text:  'Name',
          align: 'start',
          value: 'name',
        },
        {
          text:  '',
          align: 'start',
          value: 'options',
        },
        {
          text:  'Size',
          align: 'start',
          value: 'length',
        },
        {
          text:  'Last modified',
          align: 'start',
          value: 'lastModified',
        },
      ],
    };
  },
  computed: {
    ...mapState(['videoPath']),
    windowWidth: function () {
      return window.innerWidth;
    },
    tableHeight: function () {
      return 'calc(' + this.height + ' - 150px)';
    },
  },
  methods: {
    onOptionsClick(clickEvent) {
      clickEvent.stopPropagation();
      clickEvent.preventDefault();
    },
    addAudioPath(physicalPath) {
      let arrayCopy = Array.from(this.$store.state.audioPathsConfig);
      arrayCopy.push(physicalPath);
      this.$store.commit(SET_AUDIO_PATHS_CONFIG, arrayCopy);
    },
    extensionSupportedInOpenMode(fileName) {
      let extensions = restoreFileBrowserOpenModeExtensions();
      return extensions.some(e => fileName.endsWith(e));
    }
  },
  filters: {
    formatDate(value) {
      return new Date(value).toLocaleString('en-US', {
        year:   'numeric',
        month:  'numeric',
        day:    'numeric',
        hour:   'numeric',
        minute: 'numeric',
        second: 'numeric',
      });
    },
    formatFileSize(bytes) {
      if (bytes === null) {
        return '';
      }
      if (bytes === 0) {
        return '0 B';
      }

      let i = Math.floor(Math.log(bytes) / Math.log(1024));
      let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
    },
  },
};
</script>

<style scoped></style>
